/**
 * Popup with WP search bar
 */
document.addEventListener("DOMContentLoaded", () => {
  const menuSearchIcon = document.querySelector('.menu-search-icon button');
  const searchBar = document.querySelector('.menu-search-bar');
  const searchBarCloseBtn = searchBar.querySelector('.menu-search-bar__close-btn');
  const searchInput = document.querySelector('.search-form__input');

  menuSearchIcon.addEventListener('click', () => {
    searchBar.classList.toggle('active');
    menuSearchIcon.setAttribute('aria-expanded', searchBar.classList.contains('active'));
    setTimeout(() => {
      searchInput.focus();
    }, 42);
  });

  searchBarCloseBtn.addEventListener('click', closeSearchBar);

  document.addEventListener('click', (e) => {
    if (searchBar.classList.contains('active') &&
    !searchBar.contains(e.target) &&
    !menuSearchIcon.contains(e.target)) {
      closeSearchBar();
    }
  });

  searchBar.addEventListener('focusout', (e) => {
    if (searchBar.classList.contains('active') && !searchBar.contains(e.relatedTarget) && !menuSearchIcon.contains(e.relatedTarget) && !searchInput.contains(e.relatedTarget) && !searchBarCloseBtn.contains(e.relatedTarget)) {
      closeSearchBar();
    }
  });

  searchBar.addEventListener('keydown', (e) => {
    if (e.key == "Escape") {
      closeSearchBar();
    }
  });

  function closeSearchBar() {
    searchBar.classList.remove('active');
    menuSearchIcon.setAttribute('aria-expanded', 'false');
    menuSearchIcon.focus();
  }
});

